import React, { useEffect, useState } from 'react';
import { Button } from '@fluentui/react-components';
import { DismissSquare24Filled, ArrowMaximize20Regular } from '@fluentui/react-icons';
import { FullScreenHandle } from 'react-full-screen';
import { exitIcon, fullscreenIcon, IconColor, primaryIcon } from '../../styles/customStyles';

type FullScreenButtonProps = {
  handle: FullScreenHandle;
};

const FullScreenButton: React.FC<FullScreenButtonProps> = ({ handle }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleFullScreen = () => {
    if (isFullScreen) {
      handle.exit();
    } else {
      handle.enter();
    }
    setIsFullScreen(!isFullScreen);
  };

  const handleExitFullScreen = () => {
    setIsFullScreen(false);
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isFullScreen) {
        handleExitFullScreen();
        handle.exit();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isFullScreen, handle]);

  useEffect(() => {
    const onChange = () => {
      if (!document.fullscreenElement) 
        {
          setIsFullScreen(false);
        }
    };

    document.addEventListener('fullscreenchange', onChange);
    return () => {
      document.removeEventListener('fullscreenchange', onChange);
    };
  }, []);

  return (
    <Button shape="circular"style={fullscreenIcon} appearance="subtle" size="small"
      onClick={handleFullScreen}
      title={isFullScreen ? "Close Full Screen View" : "Open Full Screen View"}
      icon={isFullScreen ? <DismissSquare24Filled {...exitIcon}/> : <ArrowMaximize20Regular {...IconColor}/>}
    />
  );
};

export default FullScreenButton;
